import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.signup');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-signup',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.signup/view.scss */
:host {
  display: block;
}

.signup-page {
  width: 100%;
  max-width: 520px;
  margin: 0 auto;
}

.signup-heading {
  margin-bottom: 28px;
}

.back-link {
  display: inline-flex;
  min-height: 40px;
  align-items: center;
  margin: 0 0 20px -8px;
  padding: 0 8px;
  border-radius: 8px;
  color: #536761;
  font-size: 14px;
  font-weight: 700;
  gap: 7px;
}

.back-link:hover {
  color: var(--kiom-primary);
  background: #eaf2ef;
}

.signup-heading h2 {
  margin: 0;
  color: var(--kiom-ink);
  font-size: clamp(34px, 4vw, 38px);
  line-height: 1.2;
  letter-spacing: -0.035em;
}

.signup-heading p {
  margin: 12px 0 0;
  color: #536761;
  font-size: 14px;
  line-height: 1.65;
}

.form-alert {
  display: flex;
  align-items: flex-start;
  margin-bottom: 20px;
  padding: 13px 14px;
  border: 1px solid;
  border-radius: 10px;
  font-size: 14px;
  line-height: 1.55;
  gap: 9px;
}

.form-alert svg {
  width: 18px;
  min-width: 18px;
  margin-top: 1px;
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 2;
}

.form-alert.is-error {
  border-color: #d9a19b;
  color: #7a302b;
  background: #fff3f2;
}

.form-alert.is-success {
  border-color: #a8cfc2;
  color: #245d50;
  background: #edf7f3;
}

.signup-form {
  display: grid;
  gap: 18px;
}

.field-group {
  min-width: 0;
}

.field-group > label,
.field-group > legend {
  display: block;
  margin-bottom: 8px;
  color: #334b45;
  font-size: 14px;
  font-weight: 700;
}

.signup-form input[type=text],
.signup-form input[type=email],
.signup-form input[type=password] {
  width: 100%;
  height: 54px;
  padding: 0 15px;
  border: 1px solid #829891;
  border-radius: 10px;
  color: var(--kiom-ink);
  background: white;
  font-family: inherit;
  font-size: 16px;
  outline: none;
  transition: border-color 0.15s, box-shadow 0.15s, background 0.15s;
}

.signup-form input[type=text]:hover,
.signup-form input[type=email]:hover,
.signup-form input[type=password]:hover {
  border-color: #607a72;
}

.signup-form input[type=text]:focus,
.signup-form input[type=email]:focus,
.signup-form input[type=password]:focus {
  border-color: var(--kiom-primary);
  box-shadow: 0 0 0 3px rgba(23, 111, 91, 0.14);
}

.signup-form input::placeholder {
  color: #647872;
}

.field-group.has-error input[type=text],
.field-group.has-error input[type=email],
.field-group.has-error input[type=password] {
  border-color: #ad4a43;
  background: #fffafa;
}

.field-group.has-error input:focus {
  box-shadow: 0 0 0 3px rgba(173, 74, 67, 0.13);
}

.signup-form fieldset {
  margin: 0;
  padding: 0;
  border: 0;
}

.type-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.type-option {
  display: grid;
  min-height: 68px;
  align-items: center;
  padding: 12px 14px;
  border: 1px solid #829891;
  border-radius: 10px;
  background: white;
  cursor: pointer;
  grid-template-columns: auto 1fr;
  gap: 11px;
  transition: border-color 0.15s, box-shadow 0.15s, background 0.15s;
}

.type-option:hover {
  border-color: #607a72;
}

.type-option.is-selected {
  border-color: var(--kiom-primary);
  background: #f4faf7;
  box-shadow: 0 0 0 3px rgba(23, 111, 91, 0.1);
}

.field-group.has-error .type-option {
  border-color: #ad4a43;
}

.type-option input {
  width: 18px;
  height: 18px;
  margin: 0;
  accent-color: var(--kiom-primary);
}

.type-option strong,
.type-option small {
  display: block;
}

.type-option strong {
  color: var(--kiom-ink);
  font-size: 14px;
}

.type-option small {
  margin-top: 3px;
  color: #536761;
  font-size: 13px;
}

.password-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.input-with-action {
  position: relative;
}

.input-with-action input {
  padding-right: 76px !important;
}

.password-toggle {
  position: absolute;
  top: 5px;
  right: 5px;
  min-width: 62px;
  height: 44px;
  padding: 0 8px;
  border: 0;
  border-radius: 8px;
  color: #285f53;
  background: #edf4f1;
  font-family: inherit;
  font-size: 13px;
  font-weight: 700;
}

.password-toggle:hover {
  color: #143f36;
  background: #dfece7;
}

.field-support {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  margin-top: 8px;
  gap: 6px 12px;
}

.field-hint,
.field-error,
.caps-warning {
  display: block;
  font-size: 13px;
  line-height: 1.5;
}

.field-hint {
  color: #536761;
}

.field-error {
  margin-top: 7px;
  color: #922f2a;
  font-weight: 700;
}

.caps-warning {
  color: #8a4b0b;
  font-weight: 700;
}

.agreement-field {
  min-width: 0;
}

.agreement {
  display: flex;
  align-items: flex-start;
  color: #425951;
  font-size: 14px;
  line-height: 1.55;
  gap: 9px;
}

.agreement input {
  width: 18px;
  height: 18px;
  flex: 0 0 auto;
  margin: 2px 0 0;
  accent-color: var(--kiom-primary);
}

.agreement.has-error {
  color: #7a302b;
}

.primary-button {
  width: 100%;
  height: 54px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 10px;
  color: white;
  background: var(--kiom-primary);
  font-family: inherit;
  font-size: 15px;
  font-weight: 700;
  gap: 8px;
  transition: background 0.15s, transform 0.15s;
}

.primary-button:hover:not(:disabled) {
  background: var(--kiom-primary-dark);
}

.primary-button:active:not(:disabled) {
  transform: translateY(1px);
}

.primary-button:disabled {
  cursor: wait;
  opacity: 0.68;
}

.primary-button svg {
  width: 17px;
  height: 17px;
  fill: none;
  stroke: currentColor;
  stroke-width: 2;
}

.completion-panel {
  display: grid;
}

@media (max-width: 560px) {
  .signup-heading {
    margin-bottom: 24px;
  }
  .signup-heading h2 {
    font-size: 32px;
  }
  .type-grid,
  .password-grid {
    grid-template-columns: 1fr;
  }
}`],
})
export class PageSignupComponent implements OnInit {
    public submitting: boolean = false;
    public completed: boolean = false;
    public showPassword: boolean = false;
    public showPasswordConfirm: boolean = false;
    public capsLockOn: boolean = false;
    public formError: string = '';
    public formStatus: string = '';
    public fieldErrors: any = {};
    public data: any = {
        name: '',
        email: '',
        user_type: 'KIOM_RESEARCHER',
        password: '',
        password_confirm: '',
        agreement: false
    };

    private readonly emailPattern: RegExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    private readonly userTypes: string[] = ['KIOM_RESEARCHER', 'MEDICAL_REVIEWER'];

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        if (this.service.auth.check()) {
            this.moveFromSession();
        }
    }

    private moveFromSession() {
        let session = this.service.auth.session || {};
        if (session.account_status !== 'ACTIVE') {
            this.service.href('/status/pending');
            return;
        }
        let portals = session.portals || [];
        if (portals.length === 1) {
            this.service.href('/' + portals[0]);
            return;
        }
        this.service.href(portals.length ? '/workspace' : '/status/pending');
    }

    private focusElement(id: string) {
        window.setTimeout(() => {
            let element = document.getElementById(id) as HTMLElement;
            if (element) element.focus();
        });
    }

    private setFormError(message: string) {
        this.formStatus = '';
        this.formError = message;
        this.focusElement('signup-form-error');
    }

    private responseMessage(result: any, fallback: string): string {
        if (result && result.data && result.data.message) return result.data.message;
        return fallback;
    }

    private passwordError(password: string): string {
        if (!password) return '비밀번호를 입력해 주세요.';
        if (password.length < 10) return '비밀번호는 10자 이상이어야 합니다.';
        if (!/[A-Za-z]/.test(password)) return '비밀번호에 영문자를 포함해 주세요.';
        if (!/[0-9]/.test(password)) return '비밀번호에 숫자를 포함해 주세요.';
        if (new TextEncoder().encode(password).length > 72) {
            return '비밀번호가 너무 깁니다. 한글은 3바이트로 계산됩니다.';
        }
        return '';
    }

    private validateSignup(): boolean {
        this.fieldErrors = {};
        this.formError = '';
        this.formStatus = '';

        this.data.name = String(this.data.name || '').trim().replace(/\s+/g, ' ');
        this.data.email = String(this.data.email || '').trim().toLowerCase();
        let firstInvalid = '';

        if (this.data.name.length < 2 || this.data.name.length > 120) {
            this.fieldErrors.name = '이름은 2자 이상 입력해 주세요.';
            firstInvalid = 'signup-name';
        }
        if (!this.emailPattern.test(this.data.email)) {
            this.fieldErrors.email = '이메일 주소 형식을 확인해 주세요.';
            if (!firstInvalid) firstInvalid = 'signup-email';
        }
        if (this.userTypes.indexOf(this.data.user_type) < 0) {
            this.fieldErrors.user_type = '사용자 유형을 선택해 주세요.';
            if (!firstInvalid) firstInvalid = 'signup-type-researcher';
        }

        let passwordMessage = this.passwordError(String(this.data.password || ''));
        if (passwordMessage) {
            this.fieldErrors.password = passwordMessage;
            if (!firstInvalid) firstInvalid = 'signup-password';
        }
        if (!this.data.password_confirm) {
            this.fieldErrors.password_confirm = '비밀번호를 한 번 더 입력해 주세요.';
            if (!firstInvalid) firstInvalid = 'signup-password-confirm';
        } else if (this.data.password !== this.data.password_confirm) {
            this.fieldErrors.password_confirm = '입력한 비밀번호가 서로 다릅니다.';
            if (!firstInvalid) firstInvalid = 'signup-password-confirm';
        }
        if (!this.data.agreement) {
            this.fieldErrors.agreement = '정보 제공에 동의해 주세요.';
            if (!firstInvalid) firstInvalid = 'signup-agreement';
        }

        if (firstInvalid) {
            this.focusElement(firstInvalid);
            return false;
        }
        return true;
    }

    private completeSignup() {
        this.completed = true;
        this.formError = '';
        this.formStatus = '계정 신청이 완료되었습니다. 로그인 후 승인 상태를 확인해 주세요.';
        this.data.password = '';
        this.data.password_confirm = '';
        this.showPassword = false;
        this.showPasswordConfirm = false;
        this.focusElement('signup-form-status');
    }

    public clearFieldError(field: string) {
        if (this.fieldErrors[field]) delete this.fieldErrors[field];
        this.formError = '';
    }

    public togglePassword(target: string) {
        if (target === 'confirm') {
            this.showPasswordConfirm = !this.showPasswordConfirm;
            this.focusElement('signup-password-confirm');
            return;
        }
        this.showPassword = !this.showPassword;
        this.focusElement('signup-password');
    }

    public updateCapsLock(event: KeyboardEvent) {
        this.capsLockOn = !!(
            event && event.getModifierState && event.getModifierState('CapsLock')
        );
    }

    public hideCapsLock() {
        this.capsLockOn = false;
    }

    public async signup() {
        if (this.submitting) return;
        if (!this.validateSignup()) return;

        let accountCreated = false;
        this.submitting = true;
        try {
            let signup: any = await this.service.request.post('/api/account/signup', {
                name: this.data.name,
                email: this.data.email,
                user_type: this.data.user_type,
                password: this.data.password
            });
            if (signup.code !== 201) {
                this.setFormError(this.responseMessage(signup, '계정을 신청하지 못했습니다. 입력 내용을 확인해 주세요.'));
                return;
            }
            accountCreated = true;

            let login: any = await this.service.request.post('/api/account/login', {
                email: this.data.email,
                password: this.data.password
            });
            if (login.code === 200) {
                location.href = login.data && login.data.next ? login.data.next : '/status/pending';
                return;
            }
            this.completeSignup();
        } catch (error) {
            if (accountCreated) {
                this.completeSignup();
                return;
            }
            this.setFormError('서버에 연결하지 못했습니다. 잠시 후 다시 시도해 주세요.');
        } finally {
            this.submitting = false;
        }
    }
}

export default PageSignupComponent;